import React from "react";
import AboutSection from "../Components/AboutSection";
import {
  FiAward,
  FiBell,
  FiCalendar,
  FiClock,
  FiFileText,
  FiMapPin,
  FiMessageCircle,
  FiTrendingDown,
  FiTruck,
} from "react-icons/fi";

const About = () => {
  return (
    <>
      <div
        className="h-[20rem] bg-cover relative bg-center flex items-center justify-start text-white"
        style={{
          backgroundImage: 'url("/img/about.jpg")',
        }}
      >
        <h1 className="text-5xl font-bold text-white absolute top-1/3 left-1/4 sm:top-1/4 sm:left-1/3 md:top-1/4 md:left-1/4 lg:top-40 lg:left-28">
          About Us
        </h1>
      </div>
      <AboutSection headingTag="h2" />
      <div className="w-[90%] mx-auto my-3 text-justify px-4">
        {/* <p className="text-md text-slate-600	 text-justify">
          For our accomplishment story, we are grateful to our Mr. Sushil, whose
          continual backing and direction have been useful to us for attaining
          exponential development in the current market. We take pride in our
          team of highly experienced professionals who are dedicated to
          delivering consistent and reliable calibration services. Our goal is
          not just to meet but to exceed your expectations, providing you with
          the peace of mind that your instruments are in capable hands.
        </p> */}
        <br />

        <p className="text-md text-slate-600	 text-justify">
          To better serve your organization's needs, we kindly request the
          entire list of instruments requiring calibration. This will enable us
          to tailor our services and provide you with a competitive quotation
          promptly.
        </p>
        <br />
      </div>

      {WhyReckonix()}
      {/* <div
        className="h-auto bg-cover  bg-center  text-white py-5"
        style={{
          backgroundImage: 'url("/img/vissonmisson.jpg")',
        }}
      >
        <h2 className="text-md md:text-5xl text-center py-5 w-[80%] mx-auto">
          Recon Calibration and Test Labs LLP FUNDAMENTAL PRINCIPLES OF WORK SINCE ITS INCEPTION
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8">
          <div className="p-5 text-center">
            <h2 className="font-extrabold	leading-snug	 py-5 text-4xl font-teko">
              OUR VISION
            </h2>
            <p className="font-extrabold text-2xl">
              Deliver Solution Through Innovation
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Innovating Tomorrow's Tech
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Inspiring Tech Innovation
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Connecting the Future{" "}
            </p>
          </div>
          <div className="p-5 text-center">
            <h2 className="font-extrabold	leading-snug	 py-5 text-4xl font-teko">
              OUR MISSION
            </h2>
            <p className="font-extrabold text-2xl">
              Empower Digital Solutions{" "}
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Connect People, Tech{" "}
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Simplify IT Challenges{" "}
            </p>
            <p className="font-extrabold text-2xl mt-5">
              Inspire Digital Growth{" "}
            </p>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default About;

const WhyReckonix = () => {
  const features = [
    {
      icon: FiAward,
      title: "Quality",
      description: "100% quality of measurements.",
    },
    {
      icon: FiMapPin,
      title: "Onsite Calibration",
      description:
        "We have onsite calibration facility of all instruments except dimension instruments.",
    },
    {
      icon: FiBell,
      title: "Cal Reminder",
      description:
        "Email notification and reminder by call when instruments are due for calibration.",
    },
    {
      icon: FiCalendar,
      title: "Flexibility",
      description:
        "We organise onsite calibration on Sunday in request basis to avoid shutdown of machines in working days.",
    },
    {
      icon: FiMessageCircle,
      title: "Fast Response",
      description:
        "Our dedicated team always will be ready to assist with customer queries, clarifications, scan copies of certificates, traceability, etc.",
    },
    {
      icon: FiFileText,
      title: "Reports Duration",
      description:
        "The calibration certificates will be arranged at your end within a week from the date of completion of calibration work.",
    },
    {
      icon: FiTrendingDown,
      title: "Competitive Prices",
      description:
        "Offering the best competitive pricing for all calibration services.",
    },
    {
      icon: FiClock,
      title: "In-Time Calibration Schedule",
      description: "We ensure timely calibration without delays.",
    },
    {
      icon: FiTruck,
      title: "Pick up & Delivery",
      description:
        "FREE Pick up & delivery will be arranged from our end for above 10 instruments.",
    },
  ];

  return (
    <section className="about-why-section">
      <div className="about-why-shell">
        <header className="about-why-header">
          <span className="about-why-kicker">The Recon advantage</span>
          <h2>Why Recon Calibration and Test Labs LLP Calibration</h2>
          <p>
            Responsive calibration support built around measurement quality,
            operational continuity and dependable customer service.
          </p>
        </header>

        <div className="about-why-grid">
          {features.map((feature, index) => {
            const FeatureIcon = feature.icon;

            return (
              <article key={feature.title} className="about-why-card">
                <div className="about-why-card-top">
                  <span className="about-why-icon">
                    <FeatureIcon aria-hidden="true" />
                  </span>
                  <span className="about-why-number" aria-hidden="true">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
